import React, { PureComponent } from "react";
import SessionManagerContainer from "../authentication/session";
import { extendSession } from "../authentication/session/sessionControl";
import Navigation from "./navigation";
import Content from "./content";
import { User } from "../../types";
import { CHANGE_PWD_PATH } from "../AppRoutes";

type HomeProps = {
  requestLogout: () => void;
  user: User;
  requestChangePassword: (
    username: string,
    oldPassword: string,
    newPassword: string
  ) => Promise<any>;
  failureMessage: string;
  setFailureMessage: (message: string | null) => {};
  initiatePasswordChange: boolean;
  history: any;
};

export default class Home extends PureComponent<HomeProps> {
  render() {
    const {
      requestLogout,
      user,
      requestChangePassword,
      failureMessage,
      setFailureMessage,
      history,
      initiatePasswordChange,
    } = this.props;

    if (initiatePasswordChange) {
      return history.push(CHANGE_PWD_PATH);
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <SessionManagerContainer extendSession={extendSession} />

        <Navigation
          requestLogout={requestLogout}
          user={user}
          requestChangePassword={requestChangePassword}
          failureMessage={failureMessage}
          setFailureMessage={setFailureMessage}
          history={history}
        />

        <div style={{ flex: "1 1 auto", overflow: "hidden", width: "100%" }}>
          <Content user={user} />
        </div>
      </div>
    );
  }
}
